// O painel fala SEMPRE com a própria origem: `/api/admin/*` é servido pela
// Pages Function, que autentica pela sessão administrativa (cookie HttpOnly) e
// repassa ao Worker de tracking.
//
// Não existe mais modo "aponte direto para o Worker": credencial no browser era
// justamente o que a sessão veio eliminar. Para desenvolver localmente, rode o
// `wrangler pages dev` (que serve as Functions) — ver README.

/** Prefixo do BFF no Pages; espelha functions/api/admin/[[path]].ts. */
export const API_PROXY_PREFIX = '/api';

/**
 * Base ABSOLUTA das chamadas: o client monta URLs com `new URL(base + path)`,
 * que exige base absoluta — string vazia lançaria `TypeError: Invalid URL`.
 */
export function getApiBaseUrl(): string {
  const origin = typeof window === 'undefined' ? 'http://localhost' : window.location.origin;
  return `${origin}${API_PROXY_PREFIX}`;
}
